import { DateTime } from "luxon";
import PKCE from "js-pkce";
export default class Auth {
  private static isLoggingOut = false;

  static #oauthClient() {
    return new PKCE({
      client_id: import.meta.env.VITE_APP_CLIENT_ID,
      redirect_uri: `${window.location.origin}/callback`,
      authorization_endpoint: import.meta.env.VITE_APP_AUTH_URI,
      token_endpoint: import.meta.env.VITE_APP_ACCESS_TOKEN_URI,
      requested_scopes: (import.meta.env.VITE_APP_SCOPES || "").split(","),
    });
  }

  static isAuthenticated() {
    const expiry = parseInt(window.sessionStorage.getItem("expiry") || '0');
    return DateTime.fromSeconds(expiry) > DateTime.now();
  }

  static authenticate(reason?: 'login_required' | 'session_expired', redirectPath = window.location.href) {
    window.sessionStorage.setItem('redirectPath', redirectPath);

    const oauth = this.#oauthClient();
    const authorizationUrl = new URL(oauth.authorizeUrl());

    if (reason) {
      authorizationUrl.searchParams.set('reason', reason);
    }

    window.location.replace(authorizationUrl.toString());
  }

  static retryAuthentication() {
    const redirectPath = window.sessionStorage.getItem('redirectPath');

    window.sessionStorage.removeItem('pkce_state');
    window.sessionStorage.removeItem('pkce_code_verifier');

    const path = redirectPath && !new URL(redirectPath, window.location.origin).pathname.startsWith('/callback')
      ? redirectPath
      : `${window.location.origin}/`;

    window.sessionStorage.setItem('redirectPath', path);

    const oauth = this.#oauthClient();
    window.location.replace(oauth.authorizeUrl());
  }

  static getToken() {
    const oauth = this.#oauthClient();
    const url = window.location.href;
    return oauth.exchangeForAccessToken(url);
  }

  static setTokens(tokens: any) {
    window.sessionStorage.setItem("access_token", tokens.access_token);
    window.sessionStorage.setItem("refresh_token", tokens.refresh_token);
    window.sessionStorage.setItem("expiry", (DateTime.now().toUnixInteger() + tokens.expires_in).toString());
  }

  static refreshToken() {

  }

  static clearSession() {
    window.sessionStorage.removeItem("uuid");
    window.sessionStorage.removeItem("project_id");
    window.sessionStorage.removeItem("access_token");
    window.sessionStorage.removeItem("refresh_token");
    window.sessionStorage.removeItem("expiry");
    window.sessionStorage.removeItem('pkce_state');
    window.sessionStorage.removeItem('pkce_code_verifier');
    window.sessionStorage.removeItem('email_response');
    window.sessionStorage.removeItem('pending_email_response');
    window.sessionStorage.removeItem('login_context_auth');
  }

  static logout(reason?: 'session_expired', redirectPath?: string) {
    if (this.isLoggingOut) {
      return;
    }

    this.isLoggingOut = true;

    if (redirectPath) {
      window.sessionStorage.setItem('redirectPath', redirectPath);
    }

    this.clearSession();

    const logoutUrl = new URL(import.meta.env.VITE_APP_LOGOUT_URI, window.location.origin);
    const redirectUrl = new URL('/login', window.location.origin);
    if (reason) {
      redirectUrl.searchParams.set('reason', reason);
    }

    logoutUrl.searchParams.set('redirect_url', redirectUrl.toString());

    window.location.replace(logoutUrl.toString());
  }

}
